import { Component, OnInit, inject } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { ButtonModule } from 'primeng/button';
import {
  EnumService,
  InstituicaoGestoraService,
  RepresentacaoInstituicaoGestoraService,
  TipoRepresentacaoInstituicaoGestoraService,
} from '../../../api/services';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { Select } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { dateRangeValidator } from '@core/validators/date-range.validator';
import { RepresentanteCardComponent } from './components/representante-card/representante-card.component';
import { AuthService } from '@core/service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { DatePickerModule } from 'primeng/datepicker';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'app-add-representante',
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    BackButtonComponent,
    Select,
    InputTextModule,
    CalendarModule,
    RepresentanteCardComponent,
    ConfirmDialogModule,
    FileUploadModule,
    DatePickerModule,
    InputMaskModule,
  ],
  providers: [
    ApiService,
    InstituicaoGestoraService,
    ConfirmationService,
    AuthService,
    EnumService,
    RepresentacaoInstituicaoGestoraService,
    TipoRepresentacaoInstituicaoGestoraService,
    DynamicDialogRef,
  ],
  templateUrl: './add-representante.component.html',
  styleUrls: ['./add-representante.component.scss'],
  standalone: true,
})
export class AddRepresentanteGestaoEmpresasComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);
  ref = inject(DynamicDialogRef);
  private authService = inject(AuthService);
  private instituicaoEnsinoService = inject(InstituicaoGestoraService);
  private representanteInstituicaoEnsinoService = inject(
    RepresentacaoInstituicaoGestoraService,
  );
  private enumService = inject(EnumService);
  private messageService = inject(MessageService);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService);
  tiposRepresentacao: any[] = [];
  nacionalidades: any[] = [
    {
      id: 1,
      designacao: 'Nacional',
    },
    {
      id: 2,
      designacao: 'Estrangeira',
    },
  ];
  representantes: any[] = [];
  representacaoForm!: FormGroup;
  isPatching = false;
  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  editIndex: number | null = null;
  private tipoRepresentacaoService = inject(
    TipoRepresentacaoInstituicaoGestoraService,
  );
  isInternalInstitution: boolean = false;
  profileEducationalInstitution: any;
  isLoading: boolean = false;

  constructor() {
    this.representacaoForm = this.fb.group({
      nomeRepresentante: ['', Validators.required],
      telefoneRepresentante: ['', [Validators.required]],
      bi: ['', Validators.required],
      emailRepresentante: ['', [Validators.required, Validators.email]],
      tipoRepresentacaoID: ['', Validators.required],
      NacionalidadeEnum: ['', Validators.required],
      ativo: [true],
      usernameRepresentante: [''],
      instituicaoGestoraID: [this.instituicaoEnsinoID, Validators.required],
      foto: [''],
    });

    this.representacaoForm.controls?.[
      'NacionalidadeEnum'
    ].valueChanges.subscribe((value: any) => {
      if (this.isPatching) return;
      this.representacaoForm.patchValue({
        bi: '',
      });
      this.onNacionalidadeChange(value);
    });

    this.representacaoForm.controls['bi'].valueChanges.subscribe(() => {
      if (this.isPatching) return;

      this.representacaoForm.patchValue({
        nomeRepresentante: '',
        telefoneRepresentante: '',
        // emailRepresentante: '',
      });
    });
  }

  ngOnInit(): void {
    this.loadTiposRepresentacao();
    this.loadNacionalidade();
    this.loadInstitutionDetails();
    // Força o estado inicial correto dos campos
    this.onNacionalidadeChange(
      this.representacaoForm.controls['NacionalidadeEnum'].value,
    );
  }

  get f() {
    return this.representacaoForm.controls;
  }

  get instituicaoEnsinoID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  loadInstitutionDetails(): void {
    this.instituicaoEnsinoService
      .show(this.instituicaoEnsinoID as any)
      .subscribe((data: any) => {
        this.profileEducationalInstitution = data;
      });
  }

  save(data: any) {
    this.confirmationService.confirm({
      header: 'Confirmar Representante?',
      message: `Tem certeza que deseja salvar?`,
      rejectButtonProps: {
        label: 'Cancelar',
        icon: 'pi pi-times',
        outlined: true,
        size: 'small',
      },
      acceptButtonProps: {
        label: 'Sim',
        icon: 'pi pi-check',
        size: 'small',
      },
      accept: () => {
        this.store(this.representantes);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Representantes cancelados',
        });
      },
    });
  }

  onConfirmSave(data: any) {}
  onRejectSave() {
    this.messageService.clear('confirmDialog');
  }

  /**
   * Para nacionalidade nacional (id == 1): campos telefone e email ficam editáveis, telefone só aceita +244 com máscara.
   * Para estrangeira: campos telefone e email SEMPRE ficam editáveis, telefone permite qualquer formato, sem máscara.
   */
  onNacionalidadeChange(value: any) {
    this.isInternalInstitution = value === 1;
    const telefoneControl = this.representacaoForm.get(
      'telefoneRepresentante',
    ) as FormControl;
    if (this.isInternalInstitution) {
      telefoneControl.setValidators([Validators.required]);
      telefoneControl.updateValueAndValidity();
      telefoneControl.enable();
      // this.representacaoForm.get('emailRepresentante')?.enable();
      // this.representacaoForm.get('nomeRepresentante')?.enable();
      [
        'telefoneRepresentante',
        'emailRepresentante',
        'nomeRepresentante',
      ].forEach((field) => {
        this.representacaoForm.get(field)?.disable();
      });
    } else {
      telefoneControl.setValidators([Validators.required]);
      telefoneControl.updateValueAndValidity();
      telefoneControl.enable();
      this.representacaoForm.get('emailRepresentante')?.enable();
      this.representacaoForm.get('nomeRepresentante')?.enable();
    }
  }

  searchDocumentNumber() {
    const biVal = this.f['bi']?.value;
    if (!biVal) return;

    this.authService.consultarBi(biVal as string).subscribe((result) => {
      const isSuccess =
        result?.retorno?.codigo == 200 ||
        result?.data?.code == 200 ||
        result?.data?.codigo == 200;
      if (isSuccess) {
        const personData = result.data?.data || result.data || {};
        const firstName = personData.first_name || personData.nome || '';
        const lastName = personData.last_name || personData.sobrenome || '';
        const nomeCompleto = `${firstName} ${lastName}`.trim();

        const patchValues: any = {};
        if (nomeCompleto) {
          patchValues.nomeRepresentante = nomeCompleto;
        }
        if (personData.numeroContacto || personData.telefone) {
          patchValues.telefoneRepresentante =
            personData.numeroContacto || personData.telefone;
        }
        if (personData.email) {
          patchValues.emailRepresentante = personData.email;
        }

        this.representacaoForm.patchValue(patchValues);

        ['emailRepresentante', 'telefoneRepresentante'].forEach((field) => {
          this.representacaoForm.get(field)?.enable();
        });
      }
    });
  }

  loadTiposRepresentacao() {
    this.tipoRepresentacaoService.list().subscribe((tiposRepresentacao) => {
      this.tiposRepresentacao = tiposRepresentacao.data;
    });
  }

  store(data: any[]) {
    this.isLoading = true;
    const total = data.length;
    let processed = 0;
    let errors = 0;
    let errorMessages: string[] = [];

    data.forEach((representante: any) => {
      const formData = new FormData();
      formData.append('emailRepresentante', representante.emailRepresentante);
      formData.append('nomeRepresentante', representante.nomeRepresentante);
      formData.append(
        'telefoneRepresentante',
        representante.telefoneRepresentante,
      );
      formData.append(
        'usernameRepresentante',
        representante.usernameRepresentante,
      );
      formData.append(
        'instituicaoGestoraID',
        this.instituicaoEnsinoID.toString(),
      );
      formData.append(
        'tipoRepresentacaoID',
        representante.tipoRepresentacaoID.toString(),
      );
      formData.append('ativo', representante.ativo.toString());
      if (representante.NacionalidadeEnum) {
        formData.append('NacionalidadeEnum', representante.NacionalidadeEnum);
      }
      if (representante.bi) {
        formData.append('bi', representante.bi);
      }
      if (representante.foto) {
        formData.append('foto', representante.foto);
      }

      this.representanteInstituicaoEnsinoService.store(formData).subscribe(
        (response) => {
          processed++;
          // Checa status code na resposta
          if (response?.retorno?.codigo && response.retorno.codigo !== 200) {
            errors++;
            const msg =
              response.retorno.mensagem ||
              'Erro desconhecido ao cadastrar representante.';
            errorMessages.push(msg);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: msg,
              life: 4000,
            });
          }
          if (processed + errors === total) {
            this.isLoading = false;
            this.finalizeSubmission(errors, errorMessages, total);
          }
          this.isLoading = false;
        },
        (error) => {
          errors++;
          processed++;
          let detail = 'Erro ao cadastrar representante.';
          if (error?.error?.retorno?.mensagem) {
            detail = error.error.retorno.mensagem;
          }
          errorMessages.push(detail);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail,
            life: 4000,
          });
          if (processed + errors === total) {
            this.isLoading = false;
            this.finalizeSubmission(errors, errorMessages, total);
          }
          this.isLoading = false;
        },
      );
    });
  }

  private finalizeSubmission(
    errors: number,
    errorMessages: string[],
    total: number,
  ) {
    if (errors === 0) {
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Todos os representantes foram cadastrados com sucesso!',
        life: 3000,
      });
      this.router.navigate([
        '/gestao-bolseiros/empresa-gestora/detalhe-instituicao-gestora',
        this.instituicaoEnsinoID,
      ]);
    } else if (errors === total) {
      this.messageService.add({
        severity: 'error',
        summary: 'Falha total',
        detail: errorMessages.join(' | '),
        life: 7000,
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Parcialmente concluído',
        detail: `Falharam ${errors} de ${total} representantes. Erros: ${errorMessages.join(
          ' | ',
        )}`,
        life: 7000,
      });
    }

    this.isLoading = false;
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }
    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }
    if (this.file) {
      this.selectedFile = this.file;
      this.representacaoForm.patchValue({ foto: this.file });
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
  }

  onSubmit() {
    const value = this.representacaoForm.getRawValue();
    if (this.representacaoForm.valid) {
      value.usernameRepresentante = !this.isInternalInstitution
        ? value.emailRepresentante
        : value.bi;
      value.foto = this.selectedFile;
      if (this.editIndex !== null) {
        this.representantes[this.editIndex] = value;
        this.editIndex = null;
      } else {
        this.representantes.push(value);
      }
      this.representacaoForm.reset();
      this.isInternalInstitution = false;
      this.representacaoForm.patchValue({
        instituicaoGestoraID: this.instituicaoEnsinoID,
        ativo: true,
      });
      this.imagePreview = null;
      this.selectedFile = null;
      this.fotoPreviewMap = {};
    } else {
      this.representacaoForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
    }
  }

  cancel() {
    this.ref.close();
  }

  editRepresentante(representante: any, index: number) {
    this.isPatching = true;
    this.representacaoForm.patchValue(representante);
    this.representacaoForm.patchValue({
      nomeRepresentante: representante.nomeRepresentante,
      telefoneRepresentante: representante.telefoneRepresentante,
    });
    this.selectedFile = representante.foto;
    if (representante.foto && representante.foto instanceof File) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(representante.foto);
    } else {
      this.imagePreview = null;
    }
    this.editIndex = index;
    // Força o comportamento correto dos campos ao editar
    this.onNacionalidadeChange(representante.NacionalidadeEnum);
    this.isPatching = false;
  }

  desativarRepresentante(representante: any) {
    // Logic for deactivating the representative
  }

  deleteRepresentante(representante: any, index: number) {
    this.confirmationService.confirm({
      header: 'Confirmar Exclusão?',
      message: `Tem certeza que deseja excluir ${representante.nome}?`,
      accept: () => {
        this.representantes.splice(index, 1);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Representante excluído com sucesso!',
          life: 3000,
        });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Exclusão cancelada',
        });
      },
    });
  }

  loadNacionalidade() {
    this.enumService.getAllNacionalidadeEnum().subscribe((response) => {
      if (response?.data) {
        this.nacionalidades = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
    });
  }

  notificarRepresentante(representante: any) {
    // Logic for notifying the representative
  }
}
